import { getMediaChallengeInfo } from "@/services/challenges/mediaChallenges";
import {
  getCaseChallengeInfo,
  getQuizChallengeInfo,
} from "@/services/challenges/quizChallenges";
import { ChallengeType } from "@/services/challenges/types/challenges.types";
import { useQuery } from "react-query";

type useGetChallengeDetailsProps = {
  type?: "quiz" | "media" | "case";
  id?: number;
  onSuccess?: (item?: ChallengeType | undefined) => void;
};

export function useGetChallengeDetails({
  type = "media",
  id,
  onSuccess,
}: useGetChallengeDetailsProps) {
  return useQuery(
    ["challenge-details", id],
    () => {
      if (type === "quiz") {
        return getQuizChallengeInfo(id!);
      }

      if (type === "case") {
        return getCaseChallengeInfo(id!);
      }

      return getMediaChallengeInfo(id!);
    },
    { enabled: !!id, onSuccess }
  );
}
